import React from "react";
import Router from "./Router";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import hublotTheme from "./theme";
import { CssBaseline } from "@mui/material";

function App() {
    return (
        <div data-name="App">
            <ThemeProvider theme={hublotTheme}>
                <CssBaseline />
                <BrowserRouter>
                    <Router />
                </BrowserRouter>
            </ThemeProvider>
        </div>
    );
}

export default App;
